Namespace 'CustomerVisualMode'

class CustomerVisualMode.WithoutWorkCalendarValueTranslator
  translate: (dataItem) ->
    dataItem.value_no_calendar
